export { default } from './Contact';
export type { ContactPageProps } from './types';
